import { useDirection } from "hooks/direction";
import PropTypes from "prop-types";
import React from "react";
import Slider from "react-slick";
import "./carousel.scss";
import CarouselArrow from "./CarouselArrow";

const Carousel = ({ images }) => {
  const dir = useDirection();
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    rtl: dir === "rtl",
    centerMode: true,
    nextArrow: <CarouselArrow direction="right" />,
    prevArrow: <CarouselArrow direction="left" />,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="partner-carousel">
      <Slider {...settings}>
        {images.map(image => (
          <div key={image}>
            <img
              src={image}
              alt=""
              className="max-w-full px-4 h-auto mx-auto"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

Carousel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  images: PropTypes.array,
};

export default Carousel;
